import { useEffect, useState } from "react";
import { Check, RotateCcw, X } from "lucide-react";
import AppHeader from "@/components/AppHeader";
import AppSidebar from "@/components/AppSidebar";
import { api, formatApiError } from "@/lib/api";

export default function ChangeReviewPage() {
  const [items, setItems] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [feedback, setFeedback] = useState({});
  const [error, setError] = useState("");
  async function load() {
    try {
      const response = await api.get("/requests/change-requests");
      setItems(response.data);
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setLoaded(true);
    }
  }
  useEffect(() => {
    load();
  }, []);
  async function review(id, action) {
    try {
      await api.post(`/requests/change-requests/${id}/review`, {
        action,
        feedback: feedback[id] || "",
      });
      await load();
    } catch (err) {
      setError(formatApiError(err));
    }
  }
  return (
    <div className="app-shell" data-testid="change-review-shell">
      <AppSidebar activeItem="Client change requests" />
      <div className="app-content">
        <AppHeader />
        <main className="dashboard-page" data-testid="change-review-page">
          <section className="page-intro">
            <div>
              <p className="eyebrow">OPERATIONS CONTROL</p>
              <h1>Client change requests</h1>
              <p className="page-subtitle">
                Review client-requested changes after TAG has assigned a professional.
              </p>
            </div>
          </section>
          {error && <p className="form-message error-message">{error}</p>}
          <section className="evaluation-review-list">
          {items.filter((item) => item.status === "Pending").map((item) => (
              <article className="evaluation-review-card" key={item.id}>
                <div className="evaluation-review-card-heading">
                  <h2>Request {item.request_id}</h2>
                  <strong className="evaluation-status">{item.status}</strong>
                </div>
                <p>
                  <b>Requested change</b> {item.requested_change}
                </p>
                <p>
                  <b>Reason</b> {item.reason}
                </p>
                <textarea
                  data-testid={`change-review-feedback-${item.id}`}
                  placeholder="Client-facing feedback"
                  value={feedback[item.id] || ""}
                  onChange={(event) => setFeedback({ ...feedback, [item.id]: event.target.value })}
                />
                <div className="evaluation-action-row">
                  <button
                    className="button button-primary"
                    data-testid={`approve-change-${item.id}`}
                    type="button"
                    onClick={() => review(item.id, "Approved")}
                  >
                    <Check size={15} /> Approve
                  </button>
                  <button
                    className="button button-secondary"
                    data-testid={`return-change-${item.id}`}
                    type="button"
                    onClick={() => review(item.id, "Returned for Information")}
                  >
                    <RotateCcw size={15} /> Return
                  </button>
                  <button
                    className="button provider-reject-button"
                    data-testid={`decline-change-${item.id}`}
                    type="button"
                    onClick={() => review(item.id, "Declined")}
                  >
                    <X size={15} /> Decline
                  </button>
                </div>
              </article>
            ))}
          {!loaded && !items.length && <p className="operations-empty-state list-loading" data-testid="change-review-loading">Loading change requests…</p>}
          {loaded && !items.filter((item) => item.status === "Pending").length && (
              <p className="operations-empty-state" data-testid="change-review-empty-state">No client change requests need review.</p>
            )}
          </section>
        </main>
      </div>
    </div>
  );
}
